// src/components/ui/LoadingState.jsx
// One standard spinner, replacing the same `<div className="text-center
// py-5"><Spinner .../></div>` idiom repeated across ~24 files.
import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingState = ({ label = "Đang tải…", compact = false }) => (
  <div className={`text-center text-muted ${compact ? "py-3" : "py-5"}`}>
    <Spinner animation="border" variant="primary" role="status" size={compact ? "sm" : undefined} />
    {label && <div className="mt-2">{label}</div>}
  </div>
);

export default LoadingState;
